export class WriteCharacterModalArgs {
    constructor(variableName, isPassword, charCount, originValue) {
        this.variableName = variableName;
        this.isPassword = isPassword;
        this.charCount = charCount;
        this.originValue = originValue;
    }
}
